// import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Transportcompanyinpune() {



const cardData = {


    keyword: "Transport Company in Pune",

    headingDescription: "SSK Logistic is a professional transport company in Pune supporting businesses with organized goods transportation, freight movement, cargo delivery, industrial transportation, commercial distribution, truck transport, container movement, and full truck load services. With practical route planning and transportation coordination, SSK Logistic helps manufacturers, distributors, retailers, warehouses, traders, corporate businesses, and industrial units move consignments from Pune to important destinations across Maharashtra and other parts of India. The transportation approach is planned around cargo type, vehicle requirements, route distance, loading needs, delivery schedules, and business priorities, helping customers manage both regular and occasional transportation requirements through a coordinated service partner.",

    topPlaces: [
        {
            title: "Pune to Bhiwandi Goods Transportation",
            description: "SSK Logistic supports goods transportation from Pune to Bhiwandi for businesses moving warehouse inventory, commercial products, industrial materials, and distribution consignments. Planned vehicle coordination helps businesses manage regular cargo movement between Pune's industrial areas and the major warehousing hub of Bhiwandi."
        },
        {
            title: "Pune to Mumbai Freight Transport",
            description: "Freight transport from Pune to Mumbai is suitable for manufacturers, traders, distributors, and corporate businesses requiring dependable movement of commercial and industrial consignments. SSK Logistic coordinates suitable transportation arrangements based on cargo requirements, route schedules, and delivery destinations."
        },
        {
            title: "Pune to Chakan Industrial Transport",
            description: "Industrial transport between Pune and Chakan supports manufacturing units, automotive businesses, warehouses, and industrial suppliers moving machinery, components, raw materials, and finished goods. SSK Logistic plans transportation around dispatch schedules and the operational requirements of industrial cargo."
        },
        {
            title: "Pune to Surat Cargo Transport",
            description: "SSK Logistic provides cargo transport coordination from Pune toward Surat for businesses handling commercial stock, industrial supplies, machinery, textile-related goods, and distribution consignments. The service supports planned long-distance movement with route and delivery coordination."
        },
        {
            title: "Pune to Ahmedabad Truck Transportation",
            description: "Truck transportation from Pune to Ahmedabad helps businesses move larger commercial and industrial consignments between two major business regions. SSK Logistic coordinates vehicle requirements and transportation schedules for manufacturers, distributors, wholesalers, and other commercial customers."
        },
        {
            title: "Pune to Hyderabad Goods Transport",
            description: "Goods transport from Pune to Hyderabad supports interstate movement of machinery, commercial products, industrial materials, warehouse stock, and other business consignments. SSK Logistic assists with route planning and transportation coordination for long-distance cargo requirements."
        },
        {
            title: "Pune to Indore Commercial Transport",
            description: "Commercial transport from Pune to Indore is suitable for businesses moving inventory, finished products, equipment, raw materials, and distribution cargo. SSK Logistic coordinates practical transportation arrangements according to shipment size, destination requirements, and scheduled delivery timelines."
        },
        {
            title: "Pune to Bengaluru Freight Transportation",
            description: "Freight transportation from Pune to Bengaluru helps businesses manage interstate movement of industrial and commercial cargo. SSK Logistic supports manufacturers, distributors, technology businesses, and suppliers with coordinated truck transportation and delivery planning."
        },
        {
            title: "Pune to Nagpur Road Transport",
            description: "Road transport from Pune to Nagpur provides a practical option for moving commercial inventory, industrial materials, machinery, and other business consignments across Maharashtra. SSK Logistic coordinates pickup, vehicle arrangements, route planning, and destination delivery."
        },
        {
            title: "Pune to Delhi NCR Full Truck Load Transport",
            description: "Full truck load transport from Pune to Delhi NCR is suitable for businesses requiring dedicated vehicle movement for larger consignments. SSK Logistic coordinates FTL transportation according to cargo volume, loading requirements, route distance, and planned delivery schedules."
        }
    ],

    "services": [
        {
            "name": "Transport Company Pune",
            "description": "SSK Logistic operates as a transport company Pune businesses can approach for goods movement, freight transportation, industrial cargo delivery, commercial distribution, and interstate road transport. Services are coordinated around vehicle requirements, route planning, cargo type, and delivery schedules."
        },
        {
            "name": "Transport Companies in Pune",
            "description": "Businesses searching for transport companies in Pune can use SSK Logistic for organized transportation of industrial materials, commercial goods, warehouse inventory, machinery, and freight consignments. Transportation arrangements can be planned for local as well as long-distance business routes."
        },
        {
            "name": "Transportation Company Pune",
            "description": "SSK Logistic provides transportation company Pune solutions for businesses requiring structured movement of goods across local, regional, and interstate destinations. The service covers transportation planning, vehicle coordination, cargo movement, and delivery scheduling for different commercial requirements."
        },
        {
            "name": "Transport Service Pune",
            "description": "Transport service Pune requirements can be coordinated through SSK Logistic for commercial cargo, industrial goods, warehouse transfers, machinery, and distribution consignments. Transportation is organized according to shipment characteristics, destination, vehicle suitability, and required delivery timelines."
        },
        {
            "name": "Transportation Services Pune",
            "description": "SSK Logistic offers transportation services Pune businesses can use for regular and occasional movement of goods, freight, cargo, industrial materials, and commercial inventory. Route planning and vehicle coordination help create a practical transportation arrangement for different shipment requirements."
        },
        {
            "name": "Goods Transport Company Pune",
            "description": "As a goods transport company Pune businesses can approach, SSK Logistic supports the movement of raw materials, finished products, commercial inventory, machinery, equipment, and other business goods. Transportation planning considers cargo size, route distance, loading requirements, and delivery schedules."
        },
        {
            "name": "Goods Transportation Pune",
            "description": "Goods transportation Pune services from SSK Logistic are suitable for manufacturers, distributors, retailers, wholesalers, and industrial businesses moving products between warehouses, factories, markets, and customer locations. Planned vehicle coordination supports organized cargo movement."
        },
        {
            "name": "Freight Transport Company Pune",
            "description": "SSK Logistic supports freight transport company Pune requirements with coordinated movement of heavier commercial and industrial consignments. Suitable transportation arrangements can be planned according to freight dimensions, shipment quantity, destination, loading conditions, and delivery requirements."
        },
        {
            "name": "Cargo Transport Company Pune",
            "description": "Cargo transport company Pune services from SSK Logistic help businesses move commercial shipments, industrial supplies, machinery, equipment, and warehouse inventory. Pickup and delivery arrangements are coordinated to support efficient cargo movement across planned routes."
        },
        {
            "name": "Industrial Transport Company Pune",
            "description": "SSK Logistic provides industrial transport company Pune solutions for factories, manufacturing units, industrial suppliers, and infrastructure businesses requiring transportation of raw materials, components, machinery, finished products, and operational equipment."
        },
        {
            "name": "Commercial Transport Company Pune",
            "description": "Commercial transport company Pune services are designed for retailers, wholesalers, distributors, traders, and corporate businesses moving inventory and commercial consignments. SSK Logistic coordinates transportation based on shipment volume, route, vehicle requirements, and business delivery schedules."
        },
        {
            "name": "Logistics Transport Company Pune",
            "description": "SSK Logistic supports logistics transport company Pune requirements by coordinating transportation between suppliers, warehouses, factories, distribution centers, and customer locations. The service combines route planning, vehicle coordination, cargo movement, and delivery management."
        },
        {
            "name": "Road Transport Company Pune",
            "description": "Road transport company Pune services from SSK Logistic provide businesses with practical ground transportation for local, regional, and interstate goods movement. Routes can be planned for industrial cargo, commercial inventory, freight consignments, and warehouse transfers."
        },
        {
            "name": "Truck Transport Company Pune",
            "description": "SSK Logistic assists businesses searching for truck transport company Pune services with transportation arrangements for larger commercial and industrial consignments. Vehicle planning is aligned with cargo quantity, loading requirements, route distance, and destination delivery schedules."
        },
        {
            "name": "Container Transport Company Pune",
            "description": "Container transport company Pune services from SSK Logistic support businesses requiring organized movement of containerized cargo between industrial facilities, warehouses, distribution points, and commercial destinations. Transportation planning considers container requirements and route-specific delivery coordination."
        },
        {
            "name": "Reliable Transport Company Pune",
            "description": "Businesses looking for a reliable transport company Pune can use SSK Logistic for planned movement of goods, freight, cargo, machinery, and commercial inventory. Consistent coordination and scheduled transportation support help businesses manage their regular shipment requirements."
        },
        {
            "name": "Best Transport Company Pune",
            "description": "SSK Logistic serves businesses searching for a best transport company Pune option by offering structured transportation support for industrial, commercial, freight, and cargo requirements. Services are organized around practical vehicle selection, route planning, and delivery coordination."
        },
        {
            "name": "Professional Transport Company Pune",
            "description": "SSK Logistic provides professional transport company Pune services for businesses requiring organized movement of commercial and industrial goods. Transportation arrangements are coordinated with attention to cargo requirements, pickup schedules, route planning, and destination delivery."
        },
        {
            "name": "Transport Service Provider Pune",
            "description": "As a transport service provider Pune businesses can work with, SSK Logistic supports goods transportation, freight movement, cargo delivery, truck transport, and commercial distribution. Flexible arrangements can accommodate recurring routes as well as individual shipment requirements."
        },
        {
            "name": "Transporters in Pune",
            "description": "Businesses looking for transporters in Pune can coordinate with SSK Logistic for local and interstate movement of goods, industrial materials, commercial inventory, freight, and cargo. Transportation planning is adapted to shipment size, destination, vehicle requirements, and delivery schedules."
        },
        {
            "name": "Local Transport Company Pune",
            "description": "SSK Logistic supports local transport company Pune requirements for short-distance movement between factories, warehouses, markets, distribution centers, and business premises. Local transportation can be arranged for regular transfers as well as scheduled commercial deliveries."
        },
        {
            "name": "Corporate Transport Services Pune",
            "description": "Corporate transport services Pune from SSK Logistic help businesses coordinate transportation for office equipment, commercial materials, inventory, supplies, documents, and distribution requirements. Services can be structured around corporate schedules and recurring business transportation needs."
        },
        {
            "name": "Heavy Transport Company Pune",
            "description": "SSK Logistic supports heavy transport company Pune requirements for businesses moving large, heavy, or industrial consignments. Transportation planning considers cargo dimensions, weight, loading requirements, route conditions, and destination-specific delivery arrangements."
        },
        {
            "name": "Full Truck Load Transport Pune",
            "description": "Full truck load transport Pune services from SSK Logistic are suitable for businesses requiring dedicated vehicle capacity for larger consignments. FTL movement can be coordinated according to cargo volume, loading schedule, destination, route distance, and required delivery timeframe."
        },
        {
            "name": "Transport Company Near Pune",
            "description": "Businesses searching for a transport company near Pune can use SSK Logistic for local, regional, and interstate transportation requirements. The service supports factories, warehouses, commercial businesses, distributors, and industrial units with coordinated goods and freight movement."
        }
    ],

    "tableData": [
        ["Transport Company Pune", "Transport Companies in Pune"],
        ["Transportation Company Pune", "Transport Service Pune"],
        ["Transportation Services Pune", "Goods Transport Company Pune"],
        ["Goods Transportation Pune", "Freight Transport Company Pune"],
        ["Cargo Transport Company Pune", "Industrial Transport Company Pune"],
        ["Commercial Transport Company Pune", "Logistics Transport Company Pune"],
        ["Road Transport Company Pune", "Truck Transport Company Pune"],
        ["Container Transport Company Pune", "Reliable Transport Company Pune"],
        ["Best Transport Company Pune", "Professional Transport Company Pune"],
        ["Transport Service Provider Pune", "Transporters in Pune"],
        ["Local Transport Company Pune", "Corporate Transport Services Pune"],
        ["Heavy Transport Company Pune", "Full Truck Load Transport Pune"],
        ["Transport Company Near Pune", "Transport Company in Pune"]
    ],

    whychoose: [
        {
            WhyChooseheading: "Organized Goods Movement",
            WhyChoosedescription: "SSK Logistic coordinates goods transportation around cargo type, vehicle suitability, pickup requirements, route distance, and delivery schedules, helping businesses maintain a more structured transportation process."
        },
        {
            WhyChooseheading: "Industrial Transportation Experience",
            WhyChoosedescription: "Manufacturing and industrial businesses can arrange transportation for machinery, raw materials, components, finished products, and operational materials with movement plans suited to their specific logistics requirements."
        },
        {
            WhyChooseheading: "Flexible Vehicle Coordination",
            WhyChoosedescription: "Transportation arrangements can be planned according to shipment size and cargo requirements, making the service suitable for commercial loads, freight consignments, truck transportation, container movement, and full truck load requirements."
        },
        {
            WhyChooseheading: "Local and Interstate Routes",
            WhyChoosedescription: "SSK Logistic supports transportation across Pune's nearby industrial zones as well as major commercial destinations throughout Maharashtra and other states, helping businesses coordinate both short-distance and long-distance cargo movement."
        },
        {
            WhyChooseheading: "Dedicated FTL Support",
            WhyChoosedescription: "Businesses with larger consignments can coordinate full truck load transportation with dedicated vehicle planning based on cargo volume, loading requirements, route distance, and destination delivery schedules."
        },
        {
            WhyChooseheading: "Commercial Delivery Coordination",
            WhyChoosedescription: "Retailers, wholesalers, distributors, and corporate businesses receive transportation support for inventory transfers, warehouse movements, market deliveries, and other commercial consignments requiring scheduled road transportation."
        },
        {
            WhyChooseheading: "Practical Route Planning",
            WhyChoosedescription: "Each transportation requirement is considered according to origin, destination, cargo characteristics, expected schedule, and vehicle needs, allowing SSK Logistic to organize practical movement plans for different business routes."
        },
        {
            WhyChooseheading: "Business-Focused Transportation Support",
            WhyChoosedescription: "SSK Logistic focuses on the transportation needs of manufacturers, distributors, industrial units, traders, warehouses, and corporate businesses, providing coordinated support for recurring as well as one-time cargo movement requirements."
        }
    ]

};











const faqData = [
    {
        question: "What transportation services does SSK Logistic provide in Pune?",
        answer: "SSK Logistic helps businesses arrange commercial and industrial goods transportation from Pune to various destinations, with vehicle and route planning based on cargo specifications, quantity, and delivery requirements."
    },
    {
        question: "Can SSK Logistic transport goods from Pune to other parts of India?",
        answer: "Transportation can be organized from Pune toward major destinations across Maharashtra and India, including Mumbai, Nashik, Nagpur, Ahmedabad, Surat, Indore, Bengaluru, Hyderabad, Chennai, Delhi, and other locations."
    },
    {
        question: "What types of goods can be moved through SSK Logistic?",
        answer: "Businesses can discuss transportation for suitable commercial consignments such as machinery, industrial materials, equipment, packaged products, raw materials, finished goods, stock, supplies, and warehouse transfers."
    },
    {
        question: "Does SSK Logistic support regular goods transportation for businesses?",
        answer: "Companies with ongoing movement requirements can coordinate recurring transportation according to their regular routes, shipment frequency, cargo quantity, vehicle capacity, and preferred delivery schedules."
    },
    {
        question: "How does SSK Logistic choose a vehicle for goods transportation?",
        answer: "Vehicle requirements are assessed using details such as cargo weight, dimensions, volume, quantity, loading conditions, material type, route, and destination to help match the shipment with a suitable transportation option."
    },
    {
        question: "Can I arrange Pune to Mumbai transportation with SSK Logistic?",
        answer: "Yes, Pune to Mumbai goods transportation can be coordinated for businesses moving commercial stock, industrial supplies, machinery, equipment, packaged goods, and other suitable cargo between the two cities."
    },
    {
        question: "Does SSK Logistic provide transportation outside Maharashtra?",
        answer: "Beyond Maharashtra routes can also be considered, including destinations in Gujarat, Madhya Pradesh, Karnataka, Telangana, Tamil Nadu, Rajasthan, Delhi, and other states depending on the shipment and route requirements."
    },
    {
        question: "Is SSK Logistic useful for industrial transportation requirements?",
        answer: "Manufacturers, distributors, suppliers, warehouses, and industrial units can use transportation support for moving raw materials, finished products, machinery, equipment, inventory, and other business-related goods."
    },
    {
        question: "Can SSK Logistic arrange transportation based on a specific delivery schedule?",
        answer: "Transportation planning can take the expected delivery timeframe into account along with the pickup point, destination, cargo details, vehicle requirement, loading needs, and shipment frequency."
    },
    {
        question: "How can I enquire about a transport service from SSK Logistic in Pune?",
        answer: "To discuss a transport requirement, share the pickup location, destination, cargo type, approximate weight or quantity, preferred vehicle, and expected delivery timeline with SSK Logistic."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Nikhil Wagh",
        feedback: "Our company needed to move industrial equipment from Pune to Nagpur, and SSK Logistic helped coordinate the transportation according to the shipment requirements. The communication was clear throughout the process.",
        rating: 5
    },
    {
        id: 2,
        name: "Miss. Aarti Chavan",
        feedback: "We arranged commercial goods transportation from Pune through SSK Logistic for one of our regular routes. Their team understood the cargo details and coordinated the vehicle arrangement in an organized way.",
        rating: 5
    }
];

















    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Logistics Company Pune",
            link: "Logistics-Company-Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Best Logistics Companies in Pune",
            link: "Best-Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Top Logistics Companies in Pune",
            link: "Top-Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Logistics in Pune",
            link: "Logistics-in-Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Transport Company in Pune",
            link: "Transport-Company-in-Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Logistics Companies in Pune",
            link: "Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Transporters in Pune",
            link: "Transporters-in-Pune",
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Pune Transport Office",
            link: "Pune-Transport-Office",
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Best Logistics Company in Pune",
            link: "Best-Logistics-Company-in-Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Goods Transport Services in Pune",
            link: "Goods-Transport-Services-in-Pune",
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Transportation Services for Industrial",
            link: "Transportation-Services-for-Industrial",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune Transport Service for Company",
            link: "Pune-Transport-Service-for-Company",
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Industrial Transport Company in Pune",
            link: "Industrial-Transport-Company-in-Pune",
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Supply Chain Management Company in Pune",
            link: "Supply-Chain-Management-Company-in-Pune",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Cargo Transportation Company in Pune",
            link: "Cargo-Transportation-Company-in-Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Commercial Transportation Services in Pune",
            link: "Commercial-Transportation-Services-in-Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Container Transportation Company in Pune",
            link: "Container-Transportation-Company-in-Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Third Party Logistics Company in India",
            link: "Third-Party-Logistics-Company-in-India",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Transport Service",
            link: "Pune-to-Mumbai-Transport-Service",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune to Bangalore Transport Service",
            link: "Pune-to-Bangalore-Transport-Service",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Hyderabad Transport Service",
            link: "Pune-to-Hyderabad-Transport-Service",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Chennai Transport Service",
            link: "Pune-to-Chennai-Transport-Service",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Delhi Transport Service",
            link: "Pune-to-Delhi-Transport-Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Ahmedabad Transport Service",
            link: "Pune-to-Ahmedabad-Transport-Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Surat Transport Service",
            link: "Pune-to-Surat-Transport-Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Nashik Transport Service",
            link: "Pune-to-Nashik-Transport-Service",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Nagpur Transport Service",
            link: "Pune-to-Nagpur-Transport-Service",
        },
        {
            place: "/images/keyword/28.jpg",
            text: "Pune to Kolhapur Transport Service",
            link: "Pune-to-Kolhapur-Transport-Service",
        },
    ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Transport Company in Pune",
  "image": "https://ssklogistics.in/assets/images/transport-company-in-pune.webp",
  "description": "SSK Logistics is a transport company in Pune providing organized transportation support for businesses, manufacturers, distributors, traders, warehouses and commercial establishments. Transport company Pune services can assist with the movement of goods between factories, warehouses, suppliers, distribution centres, offices and customer locations. Transport companies in Pune are commonly required for regular commercial transportation, regional goods movement and planned freight requirements, while transportation company Pune services can be arranged according to cargo type, route, vehicle capacity and delivery schedule. Transport service Pune solutions are suitable for businesses looking for dependable local and regional goods movement, while transportation services Pune can support recurring as well as project-based shipments. Goods transport company Pune services can assist with the movement of commercial products, industrial materials, equipment and other consignments. Goods transportation Pune can be coordinated according to pickup locations, destinations and shipment requirements. Freight transport company Pune services are suitable for businesses handling larger commercial consignments and regular freight movement, while cargo transportation can support organized movement of different types of business goods. SSK Logistics focuses on practical vehicle coordination, route planning and scheduled transportation support to help businesses manage their goods movement requirements across Pune and connected locations.",
  "brand": {
    "@type": "Brand",
    "name": "SSK Logistics"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Contact for Transport Service Pricing",
    "availability": "https://schema.org/InStock",
    "url": "https://ssklogistics.in/transport-company-in-pune"
  }
};






    return (
        <div>
<Helmet>
  <title>
    Transport Company in Pune | Goods, Freight & Commercial Transportation Services | +91 9876543210
  </title>

  <meta
    name="description"
    content="SSK Logistics is a transport company in Pune offering goods transportation, freight transport, cargo movement and commercial transportation services for businesses."
  />

  <meta
    name="keywords"
    content="Transport Company in Pune, transport company pune, transport companies in pune, transportation company pune, transport service pune, transportation services pune, goods transport company pune, goods transportation pune, freight transport company pune, cargo transportation Pune, cargo transport company Pune, freight transportation Pune, commercial transport Pune, commercial transportation Pune, industrial transport Pune, industrial transportation Pune, goods transport services Pune, goods transportation services Pune, logistics transportation Pune, business transportation Pune, corporate transport Pune, warehouse transport Pune, warehouse transportation Pune, cargo logistics Pune, freight logistics Pune, transport service provider Pune, transportation service provider Pune, reliable transport company Pune, professional transport company Pune, local transport services Pune, regional transport Pune, interstate transport Pune, B2B transportation Pune, commercial goods transport Pune, industrial goods transport Pune, truck transport Pune, dedicated transport Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>








            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/5.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >SSK Logistics
                                : {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="cab-service-list">
                                {cardData.services.map((service, index) => (
                                    <div className="cab-service-row" key={index}>
                                        <div className="cab-service-details">
                                            <h4>{service.name}</h4>
                                            <span className="cab-service-line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="cab-service-arrow">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div> */}
                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>


                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>SSK Logistics</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">




                                        <div className="row twm-faq-section-1 m-b30">


                                            <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                                <div className="twm-faq-info-wrap">

                                                    <div className="section-head left">
                                                        <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For SSK Logistics </h2>
                                                    </div>


                                                    <div className="twm-faq-info">
                                                        <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                            <FaqSection
                                                                title=""
                                                                subtitle=""
                                                                items={faqData}
                                                            />

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919876543210 " className="pc-call">+91 9876543210 </a>
                                        </div>


                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919876543210 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919876543210 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:info@ssklogistics.in" className="pc-email">
                                            info@ssklogistics.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>SSK Logistics</strong><br />
                                            ViOffice no. 109 first Floor, Ashoka Plaza, above dominos Pizza, Beside Hyatt Hotel, Viman Nagar, Pune- 411014




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Transportcompanyinpune;